// SEO Configuration for FormCare
export const seoConfig = {
  // Default meta tags
  defaultTitle: "FormCare — HTML form backend with 150 free submissions",
  defaultDescription: "Paste one URL into your HTML form. FormCare stores submissions and files and sends email alerts. 150 free submissions a month and 10 forms, no credit card.",
  defaultKeywords: "form backend, HTML forms, form endpoint, form submission, file upload, web forms, form handler, contact form backend, form processing, developer tools, no backend forms, form API, form spam protection, form anti-spam, honeypot",
  siteUrl: "https://formcare.io",
  siteName: "FormCare",
  
  // Social media
  twitterHandle: "@formcare",
  
  // Images
  defaultOgImage: "https://formcare.io/og-image.png",
  defaultTwitterImage: "https://formcare.io/twitter-image.png",
  
  // Organization schema
  organization: {
    "@type": "Organization",
    "name": "FormCare",
    "url": "https://formcare.io",
    "logo": "https://formcare.io/logo.png",
    "legalName": "Polozhevets OÜ",
    "description": "Hosted HTML form backend. Paste one URL, store submissions and files, and get email alerts.",
    "foundingDate": "2025",
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "email": "support@formcare.io"
    }
  },
  
  // Page-specific SEO
  pages: {
    home: {
      title: "FormCare — HTML form backend with 150 free submissions",
      description: "Paste one URL into your HTML form. FormCare stores submissions and files and sends email alerts. 150 free submissions a month and 10 forms, no credit card.",
      keywords: "html form backend, form backend, form endpoint, contact form backend, form backend alternative, static site forms, file upload form, form spam protection"
    },
    login: {
      title: "Sign In - FormCare | Access Your Form Dashboard",
      description: "Sign in to your FormCare account to access your form submissions dashboard, manage endpoints, and view analytics.",
      robots: "noindex, nofollow"
    },
    register: {
      title: "Sign up free — FormCare | 150 submissions a month",
      description: "Create a free FormCare account. Paste one URL into your HTML form. 150 submissions a month and 10 forms, no credit card.",
      keywords: "sign up, register, free account, form backend, HTML forms, developer tools"
    },
    blog: {
      title: "Blog - FormCare | HTML Forms, Web Development & Backend Solutions",
      description: "Learn about HTML forms, web development, form backends, and spam protection. Tips, tutorials, and best practices for developers and businesses.",
      keywords: "HTML forms, web development, form backend, contact forms, JAMstack, tutorials, web forms guide, form spam protection"
    },
    docs: {
      title: "Documentation — FormCare | HTML form backend guide",
      description: "Connect any HTML or JavaScript form to FormCare. Quick start, file uploads, redirects, email notifications, anti-spam, limits, and API reference.",
      keywords: "FormCare documentation, form backend API, HTML form action, contact form endpoint, form anti-spam, honeypot"
    }
  },
  
  // Target keywords for SEO
  targetKeywords: [
    "form backend",
    "HTML form endpoint",
    "contact form backend",
    "form submission handler",
    "static site forms",
    "JAMstack forms",
    "serverless forms",
    "form processing service",
    "web form backend",
    "form data collection",
    "HTML form API",
    "form backend service",
    "contact form API",
    "form endpoint generator",
    "form spam protection",
    "form anti-spam",
    "honeypot form field",
    "HTML form rate limiting"
  ],
  
  // Content categories for blog
  blogCategories: [
    "Tutorial",
    "Development", 
    "Security",
    "Best Practices",
    "JAMstack",
    "Web Development",
    "Forms"
  ]
};

// Helper function to generate structured data
export const generateStructuredData = (type, data) => {
  const baseData = {
    "@context": "https://schema.org",
    ...data
  };
  
  switch (type) {
    case 'website':
      return {
        ...baseData,
        "@type": "WebSite",
        "url": seoConfig.siteUrl,
        "name": seoConfig.siteName,
        "description": seoConfig.defaultDescription,
        "publisher": seoConfig.organization
      };
      
    case 'software':
      return {
        ...baseData,
        "@type": "SoftwareApplication",
        "name": seoConfig.siteName,
        "url": seoConfig.siteUrl,
        "applicationCategory": "DeveloperApplication",
        "operatingSystem": "Web",
        "offers": {
          "@type": "Offer",
          "price": "0",
          "priceCurrency": "EUR",
          "description": "150 free submissions per month and 10 forms. Extra submissions are 2 cents each."
        },
        "creator": seoConfig.organization
      };
      
    case 'article':
      return {
        ...baseData,
        "@type": "Article",
        "publisher": seoConfig.organization,
        "author": seoConfig.organization
      };
      
    default:
      return baseData;
  }
};

export default seoConfig; 